import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, exhaustMap, map } from "rxjs/operators";

import { ExchangeService } from "../../../services/api/exchange.service";
import { ExchangeActions } from "../../actions/exchange.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class ProposalCreateEffects {
	create = createEffect(() =>
		this.actions.pipe(
			ofType(ExchangeActions.proposal.create),
			// exhaustMap, not switchMap: switchMap only cancels the first subscription — the POST has
			// already left the browser, so a duplicate dispatch would create two proposals.
			exhaustMap((action) =>
				this.exchangeService.createProposal(action.proposal).pipe(
					map((id) => ExchangeActions.proposal.createSuccess({ id })),
					catchError((error) =>
						of(ExchangeActions.proposal.createFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private exchangeService: ExchangeService
	) {}
}
